// Локальные предпочтения меты dg_prefs_v1: громкости, пресет-аватар, имя гостя.
// Философия та же, что у сейва (§5.2): источник правды — локально/optimistic;
// залогиненному экраны дополнительно шлют PATCH /me (displayName / settings-мёрж
// в player_state.settings) — но читаем всегда локально: GET-поверхности настроек
// у бэкенда пока нет.
// Обвязка localStorage (кэш, try/catch, storage-событие вкладок) — persistedStore.

import { useSyncExternalStore } from 'react';
import { createPersistedStore } from '@/meta/persistedStore';

export interface Prefs {
  /** громкости 0..1 — прокидываются в LevelConfig.settings плеера */
  music: number;
  sfx: number;
  /** id пресета из avatars.ts; своя картинка не загружается — только набор игры */
  avatarId: string;
  /** ник гостя (у залогиненного ник = me.displayName, это поле не используется) */
  guestName: string;
}

export const DEFAULT_PREFS: Prefs = {
  music: 0.6,
  sfx: 0.8,
  avatarId: 'zhitel',
  guestName: 'Гость',
};

function clamp01(v: unknown, fallback: number): number {
  const n = typeof v === 'number' ? v : NaN;
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : fallback;
}

function sanitize(raw: unknown): Prefs {
  const p = (raw ?? {}) as Partial<Prefs>;
  return {
    music: clamp01(p.music, DEFAULT_PREFS.music),
    sfx: clamp01(p.sfx, DEFAULT_PREFS.sfx),
    avatarId: typeof p.avatarId === 'string' && p.avatarId ? p.avatarId : DEFAULT_PREFS.avatarId,
    guestName: typeof p.guestName === 'string' && p.guestName.trim()
      ? p.guestName.trim().slice(0, 40)
      : DEFAULT_PREFS.guestName,
  };
}

const store = createPersistedStore<Prefs>('dg_prefs_v1', sanitize);

export function getPrefs(): Prefs {
  return store.get();
}

export function setPrefs(patch: Partial<Prefs>): Prefs {
  // патч мог прийти с мусором (ползунок за пределами 0..1) — прогоняем через sanitize
  return store.set(sanitize({ ...store.get(), ...patch }));
}

/** Тесты/дев-чит: полный сброс предпочтений. */
export function resetPrefs(): void {
  store.reset();
}

export function usePrefs(): Prefs {
  return useSyncExternalStore(store.subscribe, store.get, store.get);
}
